import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["backgroundColor"];
let _ = t => t,
  _t;
import { forwardRef } from 'react';
import { Avatar } from 'avatar-components/Avatar';
import PortalIdParser from 'PortalIdParser';
import { CONTACT, COMPANY, USER, BOT } from '../../constants/CallParticipantTypes';
import styledWithTheme, { css } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const getAvatar = ({
  objectId,
  email,
  displayName,
  objectType,
  size = 'responsive',
  dataTestId = 'avatarWrapper',
  onClick,
  marginBlockStart
}) => {
  const portalId = PortalIdParser.get();
  switch (objectType) {
    case USER:
    case BOT:
      return /*#__PURE__*/_jsx(Avatar, {
        vid: objectId !== null && objectId !== void 0 ? objectId : undefined,
        hubSpotUserEmail: email !== null && email !== void 0 ? email : undefined,
        displayName: displayName !== null && displayName !== void 0 ? displayName : undefined,
        size: size,
        portalId: portalId,
        "data-test-id": dataTestId,
        onClick: onClick,
        marginBlockStart: marginBlockStart
      });
    case CONTACT:
      return /*#__PURE__*/_jsx(Avatar, {
        vid: objectId !== null && objectId !== void 0 ? objectId : undefined,
        email: email !== null && email !== void 0 ? email : undefined,
        displayName: displayName !== null && displayName !== void 0 ? displayName : undefined,
        size: size,
        portalId: portalId,
        "data-test-id": dataTestId,
        onClick: onClick,
        marginBlockStart: marginBlockStart
      });
    case COMPANY:
      return /*#__PURE__*/_jsx(Avatar, {
        companyId: objectId !== null && objectId !== void 0 ? objectId : undefined,
        displayName: displayName !== null && displayName !== void 0 ? displayName : undefined,
        size: size,
        portalId: portalId,
        "data-test-id": dataTestId,
        onClick: onClick,
        marginBlockStart: marginBlockStart
      });
    default:
      return /*#__PURE__*/_jsx(Avatar, {
        vid: undefined,
        type: "contact",
        displayName: displayName !== null && displayName !== void 0 ? displayName : undefined,
        email: email !== null && email !== void 0 ? email : 'N/A',
        size: size,
        portalId: portalId,
        "data-test-id": dataTestId,
        onClick: onClick,
        marginBlockStart: marginBlockStart
      });
  }
};
const StyledAvatarWrapper = styledWithTheme.div(_t || (_t = _`
  ${0}
`), ({
  backgroundColor,
  theme
}) => backgroundColor && css(["svg{fill:", " !important;color:", " !important;}& > div > div,svg{background-color:", ";}"], theme.color['text-core-on-fill-default'], theme.color['text-core-on-fill-default'], theme.color[backgroundColor]));
export const AvatarWrapper = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      backgroundColor
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledAvatarWrapper, {
      ref: ref,
      "data-test-id": "avatar-wrapper",
      backgroundColor: backgroundColor,
      children: getAvatar(props)
    })
  );
});